import {
  Component,
  Input,
  ViewChild,
  ElementRef,
  Output,
  EventEmitter,
  HostBinding,
  OnInit,
  OnDestroy
} from '@angular/core';
import { Curso } from "../../interfaces/curso.interface";
import { CursosService } from "../../services/cursos.service";
import { ContainerBotaoComponent } from "../container-botao/container-botao.component";
import { CommonModule } from "@angular/common";
import { TraducaoService } from "../../services/traducao.service";
import { Subscription } from "rxjs";
import { IdiomaService } from "../../services/idioma.service";
import {TraducoesTags} from "../../interfaces/tag.interface";


@Component({
  selector: 'app-cursos',
  standalone: true,
  imports: [
    ContainerBotaoComponent,
    CommonModule,
  ],
  templateUrl: './cursos.component.html',
  styleUrl: './cursos.component.css'
})
export class CursosComponent implements OnInit, OnDestroy {
  @Input() cursosAgrupados: { [tag: string]: Curso[] } = {};
  @Input() isScrollAtTop: boolean = true;

  @ViewChild('scrollContainer') scrollContainer!: ElementRef<HTMLElement>;

  @Output() voltarHome: EventEmitter<void> = new EventEmitter<void>();

  @HostBinding('class.show') show: boolean = false;

  cursosTraduzidos: { [tag: string]: Curso[] } = {};
  tempoTraduzido: string = '';

  idiomaAtual: 'pt-br' | 'en' | 'es' = 'pt-br';

  private subscriptions: Subscription[] = [];

  constructor(
    private cursosService: CursosService,
    private traducaoService: TraducaoService,
    private idiomaService: IdiomaService
  ) {}

  ngOnInit(): void {
    this.carregarCursosAgrupados();
    setTimeout((): void => {
      this.show = true;
    }, 100);

    this.subscriptions.push(
    this.idiomaService.idioma$.subscribe((idioma: 'pt-br' | 'en' | 'es'): void => {
      console.log('Idioma alterado para:', idioma);
      this.idiomaAtual = idioma;
      this.carregarCursosAgrupados();
      this.atualizarCursosTraduzidos();
      this.atualizarTempoTraduzido();
    })
    );
    this.atualizarTempoTraduzido();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  carregarCursosAgrupados(): void {
    const cursos: Curso[] = this.cursosService.getCursos();
    const traducoesTags:TraducoesTags = this.traducaoService.obterTraducaoTags(this.idiomaAtual);
    this.cursosAgrupados = {};
    cursos.forEach(curso => {
      let tag: string = curso.tag;
      if(traducoesTags[curso.tag.toLowerCase()]) {
        tag = traducoesTags[curso.tag.toLowerCase()];
      }
      if (!this.cursosAgrupados[tag]) {
        this.cursosAgrupados[tag] = [];
      }
      this.cursosAgrupados[tag].push(curso);
    });
    this.atualizarCursosTraduzidos();
  }

  atualizarCursosTraduzidos(): void {
    const traducoesCursos: { [tag: string]: Curso[] } = {};

    Object.keys(this.cursosAgrupados).forEach(tag => {
      traducoesCursos[tag] = this.cursosAgrupados[tag].map(curso => {
        const cursoTraduzido = { ...curso };

        if(this.idiomaAtual === 'en') {
          cursoTraduzido.nome = curso.nomeEn || curso.nome;
        } else if (this.idiomaAtual === 'es') {
          cursoTraduzido.nome = curso.nomeEs || curso.nome;
        } else {
          cursoTraduzido.nome = curso.nome;
        }
        return cursoTraduzido;
        });
      });
      this.cursosTraduzidos = traducoesCursos;
  }

  atualizarTempoTraduzido(): void {
    this.subscriptions.push(
      this.traducaoService.obterTraducao('tempo').subscribe({
        next: traducao => this.tempoTraduzido = traducao,
        error: error => console.error('Erro ao obter tradução para tempo:', error)
      })
    );
  }

  navegarParaTag(tag: string): void {
    const element:HTMLElement | null = document.getElementById(tag);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }

  limparNomeTag(tag: string): string {
    return tag.toLowerCase()
      .replace(/ /g, '')
      .replace(/&/g, '')
      .replace(/otros|others/g, 'outros');
  }

  onScroll(): void {
    if (this.scrollContainer) {
      const scrollTop: number = this.scrollContainer.nativeElement.scrollTop;
      this.isScrollAtTop = scrollTop === 0;
    }
  }

  scrolltoTop(): void {
    if (this.scrollContainer && this.scrollContainer.nativeElement) {
      const scrollElement:HTMLElement = this.scrollContainer.nativeElement;
      scrollElement.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  onVoltarHome(): void {
    this.voltarHome.emit();
  }

  protected readonly Object: ObjectConstructor = Object;
}
